<template>
  <div class="radial-progress-container">
    <div @click="emitCurrentInfo($event)" class="col-xs-offset-4 col-xs-8 col-sm-offset-0 col-sm-11 col-md-offset-2 col-md-10 col-lg-offset-2 col-lg-10 width padding-left-0Perc padding-right-0Perc">
      <svg-progress-bar class="radial-progress-bar cursor-pointer col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-left-0Perc padding-right-0Perc" :value="count" :options="options.options" text="test"></svg-progress-bar>
      <!-- <div class="chart-label">{{ label }}</div> -->
      <span class="information_icon">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 cursor-pointer tooltip1 font-size-16px padding-left-0Perc padding-right-0Perc">
          <i class="col-xs-offset-1 col-xs-2 col-sm-offset-0 col-sm-3 col-md-offset-0 col-md-3 col-lg-offset-0 col-lg-3 glyphicon glyphicon-info-sign padding-left-0Perc padding-right-0Perc text-align-right"><span class="tooltiptext1 font-size-12px" v-html="tooltip"></span></i>
          <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9 padding-right-0Perc padding-left-7px text-align-left" v-html="label"></div>
        </div>
      </span>
    </div> 
  </div>
</template>

<script>
import SvgProgressBar from 'svg-progress-bar'

export default {
  components: {
    'svg-progress-bar': SvgProgressBar
  },

  props: {
    label: {
      type: String,
      required: true
    },
    count: {
      type: Number,
      required: true
    },
    tooltip: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      options: {
        options: {
          radius: 70,
          circleWidth: 5,
          duration: 200,
          pathColors: ['#DCDCDC', '#27345B'],
          valRate: 1,
          circleLinecap: 'round',
          textColor: '#27345B',
          text: function (value) {
            return `${this.htmlifyNumber(value)}<span style="font-size: 0.4em;">%</span>`
          }
        }
      }
    }
  },

  mounted () {
    this.setOptions()
  },

  computed: {
    chartValue () {
      console.log('COUNT VAL : ', this.count)
      return ((this.count && this.count > 0) || typeof this.count !== 'undefined') ? this.count : 0
    }
  },

  methods: {
    setOptions () {
      this.options = {
        type: 'circle',
        options: {
          radius: 70,
          circleWidth: 5,
          duration: 200,
          pathColors: ['#DCDCDC', '#27345B'],
          valRate: 1,
          circleLinecap: 'round',
          text: this.chartLabel,
          textColor: '#27345B'
        }
      }
    },

    emitCurrentInfo: function ($event) {
      var obj = {
        label: this.label,
        count: this.count
      }
      this.$emit('cureentData', obj)
    }
  }
}
</script>

<style lang="scss" scoped>
.radial-progress-container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  // height: 100vh;
}
.color-red{
  border: 1px solid red;
}
.height-65px{
 height: 65px;
}
.height-150px{
 height: 175px;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.background-color{
  background-color:#fafafa;
}
.font-color{
  color:#27345B !important;
}
.font-size-60px{
  font-size: 60px;
}
.padding-top-1Perc{
  padding-top:10%;
}

.radial-progress-container {
  position: relative;
  padding: 0;
}
  .chart-label {
    position: absolute;
    text-transform: uppercase;
    display: inline-block;
    margin: 0 auto;
    top: 60%;
    width: 50%;
    font-size: 0.8em;
    font-weight: normal;
    left: 24%;
  }
.information_icon {
    position: absolute;
    text-transform: uppercase;
    display: inline-block;
    margin: 0 auto;
    top: 62%;
    width: 77%;
    font-size: 0.8em;
    font-weight: normal;
    left: 13%;
  }

.circles-text {
  line-height: 1em !important;
}
.text-align-right{
  text-align:right;
}
.padding-left-7px{
  padding-left:2px;
}

.tooltip1 {
    position: relative;
    display: inline-block;
    /* border-bottom: 1px dotted black; */
}
.tooltip1 .tooltiptext1 {
    visibility: hidden;
    width: 152px;
    background-color: #696969;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 5px;
    position: absolute;
    z-index: 1;
    top: 150%;
    left: 50%;
    margin-left: -71px;
    text-transform:none;
    // letter-spacing: 2px !important;
    // word-spacing: -6px !important;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
}
.tooltip1 .tooltiptext1::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #696969 transparent;
}
.tooltip1 :hover .tooltiptext1 {
    visibility: visible;
}
.font-size-12px{
  font-size:12px;
}
.width{
  width: 10em;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard_v2/RadialProgressBar.vue